module.exports = __webpack_public_path__ + "static/title-1-7f3b103442dd35ab319bfa214612be53.png";